// extracted by mini-css-extract-plugin
export default {"nameProduct":"ProductButton_nameProduct__1LSEj","btnProduct":"ProductButton_btnProduct__B-o+n"};